module.exports = __webpack_public_path__ + "static/media/what-is-air-pollution.518423f0.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/media/help-and-guides/what-is-air-pollution.jpeg
// module id = 835
// module chunks = 0